import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from '../lib/utils';

/**
 * Matches the app's other toggles (the dashboard DataNet card and the Team table, both hand-built):
 * 44×24, --brand when on, --switch-off when off. It used to be 36×20 with --primary when on, which
 * is navy (#2b3674) in light — a different blue from every other toggle — the same reason Checkbox
 * and RadioGroupItem moved to --brand.
 */
function Switch({ className, dataTestId, ...props }) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-testid={dataTestId}
      className={cn(
        'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand data-[state=unchecked]:bg-switch-off',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          // bg-switch-knob, not bg-card: the `.dark .bg-white` shim rewrites bg-card to
          // var(--card), which turned the thumb the same dark grey as the surrounding panel. The
          // token is #ffffff in both modes, so light is unchanged.
          'pointer-events-none block size-5 rounded-full bg-switch-knob shadow-md ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0'
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
